/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInboxResponseCounts,
    GetInboxResponseCountsFromJSON,
    GetInboxResponseCountsFromJSONTyped,
    GetInboxResponseCountsToJSON,
    GetInboxResponseItems,
    GetInboxResponseItemsFromJSON,
    GetInboxResponseItemsFromJSONTyped,
    GetInboxResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetInboxResponse
 */
export interface GetInboxResponse {
    /**
     * 
     * @type {Array<GetInboxResponseCounts>}
     * @memberof GetInboxResponse
     */
    counts?: Array<GetInboxResponseCounts>;
    /**
     * 
     * @type {Array<GetInboxResponseItems>}
     * @memberof GetInboxResponse
     */
    items?: Array<GetInboxResponseItems>;
}

export function GetInboxResponseFromJSON(json: any): GetInboxResponse {
    return GetInboxResponseFromJSONTyped(json, false);
}

export function GetInboxResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInboxResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'counts': !exists(json, 'counts') ? undefined : ((json['counts'] as Array<any>).map(GetInboxResponseCountsFromJSON)),
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetInboxResponseItemsFromJSON)),
    };
}

export function GetInboxResponseToJSON(value?: GetInboxResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'counts': value.counts === undefined ? undefined : ((value.counts as Array<any>).map(GetInboxResponseCountsToJSON)),
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetInboxResponseItemsToJSON)),
    };
}


